import { Col, Input, Row } from 'antd'
import React, { Component } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { I18n } from 'react-redux-i18n'
import ChevronRightIcon from '../../icons/chevron-right.svg'
import CloseIcon from '../../icons/close.svg'
import LoaderIcon from '../../icons/loading.svg'
import SearchIcon from '../../icons/search.svg'

import TheatreIcon from '../../icons/theatre.svg'

import '../../style/theatres.less'

import TheatreItem from './Item'

class Theatres extends Component {

  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.props.fetchTheatres(true)
    }
  }

  componentWillMount () {
    this.props.fetchTheatres()
  }

  getTheatres () {
    let {theatres: {theatres, fetchInProgress}, compositionFilters} = this.props
    if (!theatres.length && !fetchInProgress) {
      return (<div><p
        className="qw-center qw-font-size-medium qw-line-height-medium qw-py-medium">{I18n.t('theatre.no_theatres')}</p>
      </div>)
    }

    return theatres.map(t => <TheatreItem
      key={t.id} theatre={t}
      selectedTheatre={!!compositionFilters.theatres.find(ct => ct.id === t.id)}
      toggleTheatreFilter={this.props.toggleTheatreFilter}
    />)
  }

  hideSideBar () {
    return (<div className="qw-pt-x-small qw-border-left"
                 style={{height: `${window.innerHeight - 60}px`}}>
      <TheatreIcon className="qw-icon-medium block qw-ml-auto qw-mr-auto qw-cursor-pointer"
                   onClick={() => this.toggleSideBar()}/>
    </div>)
  }

  toggleSideBar () {
    this.props.toggleSideBar()
  }

  fetchData () {
    this.props.fetchTheatres()
  }

  handleTheatreSearchChange (e) {
    this.props.updateTheatreSearchQuery(e.target.value)
    this.props.fetchTheatres(true)

  }

  searchByTheatres () {
    this.props.fetchTheatres(true)
  }

  clearSearchByTheatres () {
    this.props.clearTheatreSearchQuery()
  }

  showSideBar () {

    return (
      <div className="theatre-list">
        <Row className="qw-left-align qw-pt-x-small qw-pb-x-small">
          <Col span={23}>
            <Row className="filter-heading-title qw-align-middle">
              <Col span={4}>
              <TheatreIcon className="qw-icon-medium block qw-ml-auto qw-mr-auto"/></Col>
              <Col span={20}>
                  <span
                    className="theatre-list-title qw-align-middle qw-font-size-medium qw-bold qw-color-text-body qw-line-height-medium">
                    {I18n.t('theatre.filterByTheatres')}
                  </span>
              </Col>
            </Row>
          </Col>
          <Col span={1} className="theatre-list-hide-icon">
            <ChevronRightIcon
              className="qw-icon-small right qw-mr-small qw-p-xx-small qw-cursor-pointer"
              onClick={() => this.toggleSideBar()}/>
          </Col>
        </Row>
        <Row>
          <div className="theatre-search-holder qw-mx-small qw-my-xx-small">
            <div className="qw-relative">
              <Input placeholder={I18n.t('theatre.searchPlaceholder')}
                     className="theatre-search qw-border qw-not-rounded qw-font-size-body"
                     value={this.props.theatres.q} onKeyPress={this._handleKeyPress}
                     onChange={(e) => this.handleTheatreSearchChange(e)}/>
              {this.props.theatres.q.length ? (
                <div
                  className="theatre-search-icon-holder qw-absolute qw-right-0 qw-top-0 qw-flex qw-items-center qw-justify-center qw-border qw-cursor-pointer"
                  onClick={() => this.clearSearchByTheatres()}>
                  <CloseIcon className="qw-icon-medium theatre-search-icon"/>
                </div>
              ) : (
                <div
                  className="theatre-search-icon-holder qw-absolute qw-right-0 qw-top-0 qw-flex qw-items-center qw-justify-center qw-border qw-cursor-pointer"
                  onClick={() => this.searchByTheatres()}>
                  <SearchIcon className="qw-icon-medium theatre-search-icon"/>
                </div>
              )
              }
            </div>
          </div>
        </Row>
        <InfiniteScroll
          next={() => this.fetchData()}
          hasMore={this.props.theatres.hasMore}
          loader={<div className="qw-flex qw-items-center qw-justify-center"><LoaderIcon
            className="qw-icon-x-large"/></div>}
          height={window.innerHeight - 140}>
          {this.getTheatres()}
        </InfiniteScroll>
      </div>
    )
  }

  render () {
    return (this.props.theatres.showSideBar ? this.showSideBar() : this.hideSideBar())
  }
}

export default Theatres



// WEBPACK FOOTER //
// ./src/app/components/theatres/List.js